import React from 'react'
import { Link } from "react-router-dom";
import { SeachSection } from '../components/SpearParts/Layouts/SeachSection';
import { Header } from '../components/SpearParts/Layouts/Header';

export const SearchOption = () => {


    return (
        <div>
            <Header />
            <section id="inner-banner">
                <div class="container">
                    <div class="bnr-div">
                        <SeachSection />
                    </div>
                    <div class="row mt-5 result-select">
                        <div class="col-lg-3 result-select">
                            <h6 class="mb-4">Advanced search</h6>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Year</option>
                                <option value="1">2022</option>
                                <option value="2">2021</option>
                                <option value="3">2020</option>
                                <option value="3">2019</option>
                                <option value="3">2018</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Region</option>
                                <option value="1">Global</option>
                                <option value="2">Europe</option>
                                <option value="3">Emirates</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Steering</option>
                                <option value="1">Power steering</option>
                                <option value="2">Speed-sensitive steering</option>
                                <option value="3">Four-wheel steering</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Body type</option>
                                <option value="1">Hatchback</option>
                                <option value="2">Sedan</option>
                                <option value="3">MUV/SUV</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Transmision type</option>
                                <option value="1">Automatic</option>
                                <option value="2">Manual</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Body</option>
                                <option value="1">Hatchback</option>
                                <option value="2">Sedan</option>
                                <option value="3">MUV/SUV</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Modification</option>
                                <option value="1">GXE10-AEPVK</option>
                                <option value="2">JCE15W-AWPVF</option>
                                <option value="3">SXE10-AEAVF</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Engine</option>
                                <option value="1">Flat Engine</option>
                                <option value="2">V-Engine</option>
                                <option value="3">Twin Cylinder</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Engine code</option>
                                <option value="1">P1234</option>
                                <option value="2">P6345</option>
                                <option value="3">P0987</option>
                            </select>
                            <select class="form-control" aria-label="Default select example">
                                <option selected="" disabled="">Grade</option>
                                <option value="1">Grade 1</option>
                                <option value="2">Grade 2</option>
                                <option value="3">Grade 3</option>
                            </select>
                        </div>
                        <div class="col-lg-9">
                            <h6 class="mb-4">Search results (12)</h6>
                            <div class="table-responsive">
                                <table class="table search-table">
                                    <tbody>
                                        <tr>
                                            <td colspan="8" class="border-td p-0">
                                                <table class="table search-inner-table head-table">
                                                    <tbody>
                                                        <tr>
                                                            <th class="align-middle" width="70">Brand</th>
                                                            <th class="align-middle" width="130">Model designation</th>
                                                            <th class="align-middle" width="70">Engine</th>
                                                            <th class="align-middle" width="70">Name</th>
                                                            <th class="align-middle" width="70">Region</th>
                                                            <th class="align-middle" width="140">Transmission </th>
                                                            <th class="align-middle" width="60">Year</th>
                                                            <th class="align-middle" width="50"></th>
                                                        </tr>
                                                    </tbody></table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="8" class="border-td p-0">
                                                <table class="table search-inner-table">
                                                    <tbody>
                                                        <tr>
                                                            <td class="align-middle first-col" width="70">Skoda</td>
                                                            <td class="align-middle sec-col" width="130">Octavia</td>
                                                            <td class="align-middle" width="70">CWVA</td>
                                                            <td class="align-middle" width="70">Ovtavia</td>
                                                            <td class="align-middle" width="70">Europe</td>
                                                            <td class="align-middle" width="140">PSU</td>
                                                            <td class="align-middle" width="60">2018</td>
                                                            <td class="align-middle" width="50">

                                                                <Link to={'/product'}>
                                                                    <img src="images/go.png" /></Link>
                                                            </td>
                                                        </tr>
                                                    </tbody></table>
                                            </td>
                                        </tr>


                                    </tbody></table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            {/* <nav class="socialmedia">
                <ul>
                    <li><a href="#"><a href="contact-us.html">Get a Quote<i class="fa fa-dollar"></i></a></a></li>
                    <li><a href="#"><a href="https://facebook.com/" target="new">Facebook <i class="fa fa-facebook"></i></a></a></li>
                    <li><a href="#"><a href="https://in.linkedin.com/" target="new">Linkedin <i class="fa fa-linkedin"></i></a></a></li>

                </ul>
            </nav> */}



        </div>
    )
}


